import PrimarySearchAppBar from './quickbar/PrimarySearchAppBar';
import { NavLink } from 'react-router-dom';
import SearchField from './quickbar/SearchField';
import { TENANTS } from '../../tenants';
import { newsEnabled } from '../../utils/site';

type Props = {
  setCartOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const Header = ({ setCartOpen }: Props) => {
  return (
    <div id="header">
      <PrimarySearchAppBar setCartOpen={setCartOpen}/>

      <div className='static-menu-desktop'>
        <nav className='app-tabs'>
          <NavLink
            exact
            to='/'
            className='app-tab'
            activeClassName='app-tab--active'
            isActive={(match, location) => !!match && !location.hash}
          >
            Home
          </NavLink>
          {TENANTS.map((t) => (
            <NavLink
              key={t.id}
              to={t.path}
              className='app-tab'
              activeClassName='app-tab--active'
            >
              {t.label}
            </NavLink>
          ))}
          <NavLink
            to='/#highlights'
            className='app-tab'
            activeClassName='app-tab--active'
            isActive={(_match, location) => location.pathname === '/' && location.hash === '#highlights'}
          >
            Highlights
          </NavLink>
          <span className='app-tab app-tab--disabled' aria-disabled='true' title='Coming soon'>
            Sales
          </span>
          {newsEnabled() && (
            <NavLink
              to='/#news'
              className='app-tab'
              activeClassName='app-tab--active'
              isActive={(_match, location) => location.pathname === '/' && location.hash === '#news'}
            >
              News
            </NavLink>
          )}
          <NavLink to='/contact' className='app-tab' activeClassName='app-tab--active'>Contact</NavLink>
        </nav>
      </div>

      <div className='static-menu-mobile'>
        <SearchField display='mobile'/>
      </div>
    </div>
  )
}

export default Header;
